<template>
  <el-container class="index-con">
    <el-aside :class="showclass">
      <leftnav @send="getCurrentTab"></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <navcon></navcon>
      </el-header>
      <el-main clss="index-main">
        <div class="tab">
          <el-tabs v-model='activeName' type='border-card' closable @tab-remove='handleRemove' @tab-click="getTab">
            <el-tab-pane v-for='t in tabs' :key="t.url" :url='t.url' :name="t.url" :label="t.menuname">
            </el-tab-pane>
          </el-tabs>
        </div>
        <router-view v-show="activeName"></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../components/navcon.vue'
import leftnav from '../components/leftnav.vue'

export default {
  name: 'index',
  data() {
    return {
      activeName: '首页',
      tabs: [],
      showclass: 'asideshow',
      showtype: false
    }
  },
  // 注册组件
  components: {
    navcon,
    leftnav
  },
  methods: {
    handleRemove(targetName) {
      this.tabs = JSON.parse(window.localStorage.getItem('tab'));
      this.tabs.forEach((item, index) => {
        if (item.url === targetName) {
          this.tabs.splice(index, 1)
          window.localStorage.setItem('tab', JSON.stringify(this.tabs))
        }
      });
    },
    getTab(target) {
      this.activeName = target.label
      this.$router.push(target.name);
      this.$forceUpdate();
    },
    getCurrentTab(data) {
      let tabs = JSON.parse(window.localStorage.getItem('tab'));
      let f = false;
      tabs.forEach(item => {
        if (item.menuname == data.menuname) {
          f = true
        }
      })
      if (!f) {
        this.activeName = data.menuname
        tabs.push({menuname: data.menuname, url: "/" + data.url})
        window.localStorage.setItem('tab', JSON.stringify(tabs))
        this.$router.go(0)
      }
    }
  },
  created() {
    this.tabs = window.localStorage.getItem('tab')
    let url = document.URL;
    let tu = url.split('#')
    if (!this.tabs) {
      let home = [{"menuname": "首页", "url": "/home/index"}]
      window.localStorage.setItem('tab', JSON.stringify(home))
      this.tabs = home
    } else {
      this.tabs = JSON.parse(window.localStorage.getItem('tab'))
      this.tabs.forEach(item => {
        if (item.url == tu[1]) {
          this.activeName = item.menuname
        }
      })
    }
    // 监听
    this.$root.Bus.$on('toggle', value => {
      if (value) {
        this.showclass = 'asideshow'
      } else {
        setTimeout(() => {
          this.showclass = 'aside'
        }, 300)
      }
    })
  },
  beforeUpdate() {
  },
  // 挂载前状态(里面是操作)
  beforeMount() {

  }
}
</script>
<style scoped>
.tab {
  display: flex;
  height: 25px;
  margin-bottom: 40px;
}

.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}

.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}

.index-header,
.index-main {
  padding: 0px;
  border-left: 2px solid #333;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue